export default {
  meEndpoint: '/v1/dashboard/accounts/me/',
  loginEndpoint: '/v1/dashboard/auth/token/',
  refreshEndpoint: '/v1/dashboard/auth/token/refresh/',
  acceptInviteEndpoint: '/v1/invitations/accept_invitation/',
};
